import * as React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import { Button, Tooltip, OutlinedInput, Dialog } from "@mui/material";
import Rating from "@mui/material/Rating";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CloseIcon from "@mui/icons-material/Close";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import images from "../../../global-styles/images";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ButtonBase from "@mui/material/ButtonBase";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import CustomInput from "../../CustomInput";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { appLogger } from "../../../utils";
import "./PreviewStyles/index.css";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  boxShadow: "none",
  background: "none",
}));
const MobileWidgetPreview = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "WidgetPreview",
      component: "add-product",
      fileName: "WidgetPreview.tsx",
      prpos: props,
    },
  });
  const { productParams, widgetInfo } = props;
  const [TestZoom, setTestZoom] = React.useState<any>("zoomout");

  const [previewAgent, setPreviewAgent] = React.useState(false);

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  const freqfullscreenchanged = (event: any) => {
    // document.fullscreenElement will point to the element that
    // is in fullscreen mode if there is one. If not, the value
    // of the property is null.
    if (document.fullscreenElement) {
      setTestZoom("zoomin");
    } else {
      setTestZoom("zoomout");
    }
  };

  const el: any = document.getElementById("freq-fullscreen-div");
  const tt: any = document.getElementById("freq-toggle-fullscreen");

  if (el != null) {
    el.addEventListener("fullscreenchange", freqfullscreenchanged);
    // or
    el.onfreqfullscreenchange = freqfullscreenchanged;
  }

  if (tt != null) {
    // When the toggle button is clicked, enter/exit fullscreen

    tt.addEventListener("click", (event: any) => {
      if (document.fullscreenElement) {
        // exitFullscreen is only available on the Document object.
        document.exitFullscreen();
      } else {
        el.requestFullscreen();
      }
    });
  }
  const zoomClick = () => (event: any) => {
    const fullscreendiv: any = document.getElementById("mobile-ft-req");
    if (document.fullscreenElement) {
      setTestZoom("zoomout");
      // exitFullscreen is only available on the Document object.
      document.exitFullscreen();
    } else {
      fullscreendiv.requestFullscreen();
      setTestZoom("zoomin");
    }
  };
  function createElementFromHTML(htmlString: any) {
    const svgStr = htmlString;
    const svg = new Blob([svgStr], { type: "image/svg+xml" });
    const url = URL.createObjectURL(svg);
    return url;
  }

  const renderContent = () => {
    return (
      <Grid
        className={`mobile-mockup widget-preview ${TestZoom}`}
        container
        sx={{
          mt: 1,
          p: 2,
          border: "1px solid #dbdce0",
          borderRadius: "35px",
          padding: "45px 10px 20px 10px",
          background: "#000",
          // boxShadow:
          //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
        }}
      >
        {/* <Grid className="mobile-header">
        <CloseIcon />
        <Typography className="title-sm">Widget preview</Typography>
      </Grid> */}

        <Grid
          item
          xs={12}
          md={12}
          className="preview-content"
          sx={{
            padding: "0",
            height: previewAgent ? "600px" : "390px",
            width: previewAgent ? "300px" : "230px",
            overflow: "auto",
            background: "#fff",
            borderRadius: "0 0 15px 15px",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              display: "none",
              "-ms-overflow-style": "none",
              scrollbarWidth: "none",
            },
          }}
        >
          {/* <Typography className="title">Feedback Button Preview</Typography> */}
          <Box
            className="feedbtn-wrap"
            sx={{
              position: "relative",
              flexGrow: 1,
              width: "100%",
              paddingTop: "25px",
              height: "170px",
              overflow: "hidden",
              border: "1px solid #ccc",
            }}
          >
            <Button
              disableRipple
              style={{
                // width: "auto",
                // height: 20,
                height: previewAgent ? "30px" : 20,
                width: previewAgent ? "80px" : "auto",
                lineHeight: 40,
                borderRadius: widgetInfo?.borderRadius,
                backgroundColor: widgetInfo?.buttonColor,
                color: widgetInfo?.buttonTextColor,
                textAlign: "center",
                fontSize: previewAgent ? "12px" : 5,
                fontFamily: widgetInfo?.fontSelect,
                fontWeight: widgetInfo?.fontWeight,
                fontStyle: widgetInfo?.fontStyle,
                transform: `rotate(${widgetInfo?.rotation}deg)`,
                textTransform: "none",
                position: "absolute",
                top: widgetInfo?.customTop,
                bottom: widgetInfo?.customBottom,
                left: widgetInfo?.customLeft,
                right: widgetInfo?.customRight,
                margin: widgetInfo?.margin,
                padding: widgetInfo?.padding,
                transformOrigin: widgetInfo?.transformOrigin,
              }}
            >
              {productParams.productParams?.products[0]?.feedbackAgentSettings
                .widgetLookAndFeel.icon && (
                <>
                  {" "}
                  <img
                    width="10"
                    height="10"
                    src={createElementFromHTML(
                      productParams.productParams?.products[0]
                        ?.feedbackAgentSettings.widgetLookAndFeel.icon
                    )}
                  />{" "}
                  &nbsp; &nbsp;
                </>
              )}
              {widgetInfo?.buttonText}
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Typography className="prev-text-titile">
        Widget Settings: Preview &nbsp;
      </Typography>
      {!previewAgent && (
        <Grid container justifyContent="center" mt={1} mb={1}>
          <Typography
            className="tv-agent-preview-btn guideTourViewActualSize"
            onClick={handleTogglePreview}
            sx={{ color: "#0157FF", fontSize: 12 }}
          >
            Click to preview actual size
          </Typography>
        </Grid>
      )}
      <div style={{ marginTop: "20px" }}>{renderContent()}</div>
      {previewAgent && (
        <Dialog
          open={previewAgent}
          onClose={handleTogglePreview}
          sx={{
            "& .MuiPaper-root": {
              // borderRadius: "20px",
              // maxWidth: "390px",
              // minWidth: "390px",
              // minHeight: "700px",
              // maxHeight: "844px",
              background: "transparent",
              boxShadow: "none",
              "&::-webkit-scrollbar": {
                display: "none",
                "-ms-overflow-style": "none",
                scrollbarWidth: "none",
              },
              overflow: "inherit",
              position: "relative",
            },
            "& .MuiBackdrop-root": {
              backgroundColor: "#808080",
            },
            maxWidth: "390px",
            maxHeight: "844px",
            margin: "auto",
          }}
        >
          {previewAgent && (
            <Typography className="mobile-agent-preview-close">
              For Preview
              <span onClick={handleTogglePreview} className="prevclose">
                &nbsp; x &nbsp;Close&nbsp;
              </span>
            </Typography>
          )}
          {renderContent()}
        </Dialog>
      )}
    </>
  );
};

export default MobileWidgetPreview;
